import React, { useCallback } from "react";
import { postCreateAccountAndUpdateSubscription } from "../../clients/partnersClients";
import { useApiLoaderStore } from "../../store/apiLoderStore";
import { useToastStore } from "../../store/toastStore";
import { useTransctionStore } from "../../store/transactionsStore";
type Props = {
  emailId: string;
  productType: string;
  teacherCount: number;
  isRenew: boolean;
  closeModal: () => void;
  onSuccess: () => void;
};
function CreateAccountSubscriptionDialogue(props: Props) {
  const { emailId, productType, teacherCount, isRenew, closeModal, onSuccess } =
    props;
  const showLoader = useApiLoaderStore((state) => state.showLoader);
  const showToast = useToastStore((state) => state.showToast);
  const setPartnerSubscriptionUpdateResponse = useTransctionStore(
    (state) => state.setPartnerSubscriptionUpdateResponse
  );
  const onCreateClicked = useCallback(() => {
    closeModal();
    const body = {
      userUid: null,
      emailId,
      productType,
      teacherCount,
      isRenew,
    };
    showLoader(true);
    postCreateAccountAndUpdateSubscription(body, showToast).then((response) => {
      showLoader(false);
      if (response) {
        setPartnerSubscriptionUpdateResponse(response);
        onSuccess();
      }
    });
  }, [
    emailId,
    productType,
    teacherCount,
    isRenew,
    showToast,
    showLoader,
    closeModal,
    onSuccess,
    setPartnerSubscriptionUpdateResponse,
  ]);
  return (
    <div className="modal-outer-container">
      <div className="modal-header-container">
        <label className="flex-center header">Create new account</label>
        <img
          src="/images/add-class-x.svg"
          alt=""
          style={{ cursor: "pointer", height: "24px", width: "24px" }}
          onClick={closeModal}
        />
      </div>
      <div className="modal-desc">
        Are you sure want to create a new account for {emailId} and set up this
        subscription?
      </div>
      <div className="modal-bottom-actionbar">
        <button className="button-v2 outline-btn" onClick={closeModal}>
          Close
        </button>
        <button type="submit" className="button-v2" onClick={onCreateClicked}>
          Create
        </button>
      </div>
    </div>
  );
}

export default CreateAccountSubscriptionDialogue;
